import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config";
import { log } from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getRolesList = async (token) => {
    log("welcome in getRolesList from web")
    if (!token || token === "") {
        alert("No token in getRolesList")
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/getRolesListApi'
        const result = await axios.get(url, { headers: headers })
        log("result.data din axios getRolesList")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getRolesList")
        log(err)
        error.value = err.message
        return { error: true, message: "Error loading roles list" }
    }
}

export const addRole = async (token, roleData) => {
    log("welcome in addRole from web")
    if (!token || token === "") {
        alert("No token in addRole")
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/addRoleApi'
        const params = {
            name: roleData.name,
            description: roleData.description,
            is_protected: roleData.is_protected || false,
            available_to_subclients: roleData.available_to_subclients || false,
            available_only_to_distributors: roleData.available_only_to_distributors || false
        };
        const result = await axios.post(url, params, { headers: headers })
        log("result.data din axios addRole")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in addRole")
        log(err)
        error.value = err.message
        return { error: true, message: "Error adding role" }
    }
}

export const updateRole = async (token, roleData) => {
    log("welcome in updateRole from web")
    if (!token || token === "") {
        alert("No token in updateRole")
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/updateRoleApi'
        const params = {
            id: roleData.id,
            name: roleData.name,
            description: roleData.description,
            is_protected: roleData.is_protected || false,
            available_to_subclients: roleData.available_to_subclients || false,
            available_only_to_distributors: roleData.available_only_to_distributors || false
        };
        const result = await axios.put(url, params, { headers: headers })
        log("result.data din axios updateRole")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in updateRole")
        log(err)
        error.value = err.message
        return { error: true, message: "Error updating role" }
    }
}

export const deleteRole = async (token, role_id) => {
    log("welcome in deleteRole from web")
    if (!token || token === "") {
        alert("No token in deleteRole")
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/deleteRoleApi'
        const params = { role_id: role_id };
        const result = await axios.delete(url, { headers: headers, data: params })
        log("result.data din axios deleteRole")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in deleteRole")
        log(err)
        error.value = err.message
        return { error: true, message: "Error deleting role" }
    }
}

export const toggleUserRole = async (token, user_id, role_id) => {
    log("welcome in toggleUserRole from web")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/toggleUserRole'
        const params = { user_id: user_id, role_id: role_id };
        const result = await axios.post(url, params, { headers: headers })
        log("result.data din axios toggleUserRole")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in toggleUserRole")
        log(err)
        error.value = err.message
        return { error: true, message: "Error toggling user role" }
    }
}

export const getUsersByRole = async (token, role_id) => {
    log("welcome in getUsersByRole from web")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/getUsersByRoleApi'
        const params = { role_id: role_id };
        const result = await axios.get(url, { headers: headers, params })
        log("result.data din axios getUsersByRole")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getUsersByRole")
        log(err)
        error.value = err.message
        return { error: true, message: "Error getting users by role" }
    }
}

const useGetRolesAPI = () => {
    return { error, getRolesList, addRole, updateRole, deleteRole, toggleUserRole, getUsersByRole };
}

export default useGetRolesAPI
